import { clsModel, fnCreate } from '@cls/clsModel'
import { workorders as api } from '@/app/api'
import { workordertypes as typeApi } from '@/app/api'
import Constants from '@app/consts'
import {date} from '@lib/date'
import {relation, workordertype} from '@app/list';
import eventbus from '@app/eventbus'
import string from '@lib/string' 

var modelName = "workorder";
const id_optimit_type = Constants.optimit_types.workorder;
const ACTION_COPY   = 'workorder.copy';

const fields = [

    "id",
    "number",
    "id_workordertype",
    "id_project",
    "id_project_chapter",
    "pro_name", 
    "pro_number", 
    "pro_reference", 
    "ch_rep",
    "title",
    "id_relation",
    "id_address",
    "id_person",
    // "phone",
    "id_relation_invoice",
    "reference",
    "priority",
    "reported_at",
    "target_at",
    "estimate",
    "description",
    "appointments",
    "products",
    "invoices",
    "attachments",
    "signature_mandatory",
    "hours_mandatory",
    "note_mandatory",    
    "id_status", 
    "finished_at",  
    "canceled_at",  
    "plannable_until",  
    "can_employee_pickup",
    "pickup_by_employees",

];

class clsWorkorder extends clsModel {

    id = null;
    number = null;
    _id_workordertype = null;
    id_project = null;
    id_project_chapter = null;
    pro_name = null;
    pro_number = null;
    pro_reference = null;
    ch_rep = null;
    title = null;
    _id_relation = null;
    id_address = null;
    id_person = null;
//    phone = null;
    id_relation_invoice = null;
    reference = null;
    priority = null;
    reported_at = null;
    target_at = null;
    estimate = null;
    description = null;
    _appointments = [];
    _products = [];
    _invoices = [];
    attachments = [];
    signature_mandatory = false;
    hours_mandatory = false;
    note_mandatory = false;

    id_status = null; 
    finished_at = null;  
    canceled_at = null;  
    plannable_until = null;
    can_employee_pickup = "no";
    pickup_by_employees = [];

    get compEmployeePickupable() {
        return this.can_employee_pickup !== "no";
    }
    set compEmployeePickupable(value) {
        if (!value) {
            this.can_employee_pickup = "no";
        } else {
            this.can_employee_pickup = "all";
        }
    }

    get appointments() {
        return this._appointments;
    }
    set appointments(arr) {
        arr = arr || []; 
        this._appointments = arr.map( (item) => {return  {...item, checked: false}});         
    }
    get products() {
        return this._products;
    }
    set products(arr) {
        arr = arr || []; 
        this._products = arr.map( (item) => {return  {...item, checked: false}});         
    }
    get invoices() {
        return this._invoices;
    }
    set invoices(arr) {
        this._invoices = arr;
    }

    // Is at least one of the appointments already finished?
    get hasExecutedAppointments() {
        return !!this.appointments.find( (item) => item.finished_at);
    }

    get isFinished() {
        return !!this.finished_at;
    }
    get isCanceled() {
        return !!this.canceled_at;
    }

    get disabled() {
        if (super.disabled) {
            return true; 
        }
        if (this.isFinished) {
            return true; 
        }
        if (this.isCanceled) {
            return true; 
        }
        return false;
    }

    get id_relation() {
        return this._id_relation;
    }
    // 
    // When setting the relation AND we are not in the filling phase: 
    // - When the corresponding relation has only one address, set the id_address to that address.
    // - When the corresponding relation has only one contact person, set the id_person to that person.
    // - In any other case, clear the id_address and id_person.
    // 
    set id_relation(id) {
//         console.log('Setting id_relation: ', id, this.isFilling);
        this._id_relation = id;
        if (this.isFilling) {
            return; 
        }
        this.id_address = null;
        this.id_person  = null;
        var rel = relation.one(id); 
        if (!rel) {
            return;
        }
        if ((rel.addresses||[]).length == 1) {
            this.id_address = rel.addresses[0].id; 
        }
        if ((rel.contactpersons||[]).length == 1) {
            this.id_person = rel.contactpersons[0].id; 
        }
    }

    get id_workordertype() {
        return this._id_workordertype;
    }
    set id_workordertype(id) {
        this._id_workordertype = id;
        if (!this.isFilling) {
            var type = workordertype.one(id); 
            if (!type) {
                return;
            }
            this.estimate = type.estimate; 
            this.hours_mandatory = type.hours_mandatory; 
            this.note_mandatory = type.note_mandatory; 
            this.priority = type.priority; 
            this.signature_mandatory = type.signature_mandatory; 
        }
    }



    apiLoad(id, params) {
        params = params ||{};
        if (params.action == ACTION_COPY) {
            return this.api.copy(id, params);
        }
        return super.apiLoad(id, params);
    }
    get phone() {
        if (!this.id_relation) {
            return "";
        }
        let rel = relation.one(this.id_relation);
        if (!rel) {
            return "";
        }    
        return string.concat(" / ", rel.rel_phone, rel.rel_mobile) || "";        
    }
    get contactPhone() {
        if (!this.id_relation || !this.id_person) {
            return "";
        }
        let rel = relation.one(this.id_relation);
        if (!rel) {
            return "";
        }    
        let person = (rel.contactpersons||[]).find( (item) => item.id == this.id_person);
        if (!person) {
            return "";
        }
        return string.concat(" / ", person.prs_phone, person.prs_mobile) || "";
    }



    /**
     * The attachments which are related to the workorder. 
     * Those are attachments which are created by backoffice, not field users.
     */
    get attachmentsWorkorder() {
        return this.attachments.filter( (item) => item.is_workorder );
    }

    /**
     * The attachments which are related to the appointments.
     * Those are attachments which are created by field users, not backoffice.
     */
    get attachmentsAppointment() {
        return this.attachments.filter( (item) => !item.is_workorder );
    }

    async uploadWorkorderAttachment(formData) {
        this.isLoading = true;
        try {
            formData.append("id_workorder", this.id);
            var result = await api.uploadWorkorderAttachment(formData);
            if (result && result.data) {
                this.attachments = result.data.attachments || [];
            }
        } finally {
            this.isLoading = false;
        }
    }
    async removeAttachments(ids) {
        this.isLoading = true;
        try {
            var result = await api.removeAttachments(this.id, ids);
            if (result && result.data) {
                this.attachments = result.data.attachments || [];
            }
        } finally {
            this.isLoading = false;
        }
    }
    async setAttachmentVisibleInApp(id, bPublic) {
        this.isLoading = true;
        try {
            var result = await api.setAttachmentVisibleInApp(this.id, id, bPublic);
            if (result && result.data) {
                this.attachments = result.data.attachments || [];
            }
        } finally {
            this.isLoading = false;
        }
    }
    async renameAttachment(id, name) {
        this.isLoading = true;
        try {
            var result = await api.renameAttachment(this.id, id, name);
            if (result && result.data) {
                this.attachments = result.data.attachments || [];
            }
        } finally {
            this.isLoading = false;
        }
    }


    get modelRep() {
        return this.number;
    }

    /**
     * Override to create specific implementations. 
     */
    async doCreate(defaults) {
        defaults = defaults || {};
        defaults.reported_at = defaults.reported_at || date.iso.today(); // new Date(); 
//        defaults = defaults || {};        
//        var result = await api.loadNew();
        return await super.doCreate(defaults);
    }

    async createAppointment(appointment) {
        this.isLoading = true;
        try {
            appointment.id_workorder = this.id;
            var result = await api.createAppointment(appointment);
            if (result && result.data) {
                if (result.data.id_status != this.id_status) {
                    this.id_status = result.data.id_status;
                    this.refreshStats();
                }
                this.appointments = result.data.appointments || [];
                // Poor man's notification as the id of the appointment is not filled.
                // Send anyway as the planboard uses this kind of data to stay up to date.
                eventbus.model.saved('workorder_appointment', appointment);
            }
        } finally {
            this.isLoading = false;
        }
    }

    async removeAppointments(ids) {
        this.isLoading = true;
        try {
            var result = await api.removeAppointments(this.id, ids);
            if (result && result.data) {
                if (result.data.id_status != this.id_status) {
                    this.id_status = result.data.id_status;
                    this.refreshStats();
                }
                this.appointments = result.data.appointments || [];
            }
            eventbus.model.removed('workorder_appointment', {ids: ids});

        } finally {
            this.isLoading = false;
        }
    }
    // clear the finished_at flag for the given appointments.
    async unlockAppointments(ids) {
        this.isLoading = true;
        try {
            var result = await api.unlockAppointments(this.id, ids);
            if (result && result.data) {
                if (result.data.id_status != this.id_status) {
                    this.id_status = result.data.id_status;
                    this.refreshStats();
                }
                this.appointments = result.data.appointments || [];
            }
        } finally {
            this.isLoading = false;
        }
    }

    async updateAppointments(appointment) {
        var appo = appointment || {}; 
        if (appo.data) {
            appo = appo.data;
        }
        if (!appo.appointments) {
            return; 
        }
        this.appointments = appo.appointments || [];
    }
    

    refreshStats() {
        eventbus.model.stats.refresh('workorder');
        this.sendSavedEvent();
    }

    async changeStatus(fnCallApi) {
        this.isLoading = true;
        try {
            var result = await fnCallApi();
//            if (result && result.data) {
//                this.fill(result.data); 
//            }
            this.refreshStats();
            await this.reload();
            this.sendSavedEvent();
        } finally {
            this.isLoading = false;
        }
    }

    async toStatusPlanned()  {  await this.changeStatus(async () =>await api.toStatusPlanned([this.id])); }
    async toStatusExecuting() { await this.changeStatus(async ()=>await api.toStatusExecuting([this.id]));}
    async toStatusExecuted()  { await this.changeStatus(async ()=>await api.toStatusExecuted([this.id])); }
    async toStatusFinished()  { await this.changeStatus(async ()=>await api.toStatusFinished([this.id])); }
    async toStatusCanceled()  { await this.changeStatus(async ()=>await api.toStatusCanceled([this.id])); }

    getDetailsForAppointment(id) {
        if (!id) {  
            return null; 
        }      
        var appointment = this.appointments.find( (item) => item.id == id);
        if (!appointment) {
            return null; 
        }
        var details = {
            id: appointment.id,
            id_workorder: this.id,                                                      
            dt: appointment.dt,
            note: appointment.note, 
            note_internal: appointment.note_internal,             
            employee_name: appointment.employee_name,
            description: appointment.description || "",
            attachments: (this.attachmentsAppointment||[]).filter( (item) => item.id_appointment == id) || [],
        };                                                                               
        return details;
    }

    async saveAppointmentNote(id_appointment, note) {
        this.isLoading = true;
        try {
            var result = await api.saveAppointmentNote(this.id, id_appointment, note);
            if (result && result.data) {
                this.appointments = result.data.appointments || [];
            }
        } finally {
            this.isLoading = false;
        }
    }


    /// Materials
    async addProductLine(product) {
        console.log("addProductLine", product);
        this.isLoading = true;
        try {
            var quantity = 1; 
            if (undefined !== product.amount && null !== product.amount) {
                quantity = product.amount;
            }
            else if (undefined !== product.quantity && null !== product.quantity) {
                quantity = product.quantity;
            }
            var result = await api.addProduct(this.id, quantity, product.id);
            if (result && result.data) {
                this.products = result.data.products || [];
            }
        } finally {
            this.isLoading = false;
        }
    }
    async updateProductLine({idLine, quantity, id_unit, id_product}) {
        this.isLoading = true;
        try {
            var result = await api.saveProduct(idLine, this.id, quantity, id_unit, id_product);
            if (result && result.data) {
                this.products = result.data.products || [];
            }
        } finally {
            this.isLoading = false;
        }
    }
    /// Materials
    async removeProductLines(ids) {                
        this.isLoading = true;
        try {
            var result = await api.removeProducts(this.id, ids);
            if (result && result.data) {
                this.products = result.data.products || [];
            }
        } finally {
            this.isLoading = false;
        }
    }

    async loadCreateInvoiceData() {
        this.isLoading = true;
        try {
            var result = await api.loadCreateInvoiceData(this.id);
            return result.data || {};
        } finally {
            this.isLoading = false;
        }
    }

    async createInvoice(model) {
        this.isLoading = true; 
        model.id_workorder = this.id;
        try {
            var result = await api.createInvoice(model);
            this.invoices = result.data?.invoices || [];
            return result.data.id_invoice;
        } finally {
            this.isLoading = false;
        }
    }




    fill(data, ignoreInitialState) {
        data = data || {};
        data.estimate            = data.estimate || 0; 
        data.signature_mandatory = !!data.signature_mandatory;
        data.hours_mandatory     = !!data.hours_mandatory;
        data.note_mandatory      = !!data.note_mandatory;
        data.pickup_by_employees = data.pickup_by_employees || [];
        
        data.can_employee_pickup = data.can_employee_pickup || "no";

        return super.fill(data, ignoreInitialState);
    }
    
    registerEvents() {
        super.registerEvents(); 
        let subs = null;
        eventbus.model.removed.on( (type, para) => {
            console.log('eventbus.model.removed.on', type, para)
            if (type != 'salesinvoice') {
                return;
            }
            if (!Array.isArray(para)) {
                return;
            }
            if (!para.length) {
                return;
            }
            if (this.invoices.find( (item) => item.id == para[0])) {
                this.invoices = this.invoices.filter( (item) => item.id != para[0]);
            }
        });

        eventbus.model.saved.on( async (modelName, params, extraData) => {
            // If we are not open, we don't care about the event. 
            if (!this.isDialogOpen) {
                return;
            }

            if (modelName == 'workorder_appointment') {
                if (this.id && params.id_workorder == this.id) {
                    if (Number(params.id_status) > 0 ) {
                        this.id_status = params.id_status;
                    }
                    if (params.appointments && params.appointments.length) {
                        this.appointments = params.appointments || [];
                    }
                }
            } else if (modelName == 'salesinvoice_send') {
                // Do not use load() or reload() as this will traverse filling et all, which we don't want.
                var result = await this.apiLoad(this.id);
                var invoices = result?.data?.invoices || [];
                if (invoices && invoices.length) {
                    this.invoices = invoices;
                }
            } else if (modelName == 'salesinvoice') {
                var invoice = this.invoices.find( (item) => item.id == params.id);
                if (invoice) {
                    // Simple sync of the data from the saved invoice to our list 
                    for (let key in invoice) {
                        if (params[key] !== undefined) {
                            invoice[key] = params[key];
                        }
                    }
                }
                

            }
        })




    }

    constructor() {
        super({
          api: api,   
          modelName: modelName, 
          id_optimit_type: id_optimit_type, 

          fillable: fields
        })
    } 


 }
 export default fnCreate(clsWorkorder , 'clsWorkorder');
